<template>
  <div class="sections-lateral-spaces">
    <div class="nv-grid page-content">
      <div class="nv-grid-row">
        <div class="nv-grid-col nv-p-0">
          <div class="welcome-section nv-p-2 nv-p-md-4 nv-p-md-4">
            <div class="bg" />
            <div class="nv-mb-2">
              <img
                :src="product?.logo?.url"
                :alt="t('product_logo', { name: product?.name })"
              >
            </div>
            <div class="nv-mx-auto nv-w-100">
              <h2 class="nv-mb-4">
                {{ $t('product_help', { name: product?.name }) }}
              </h2>
  
              <div class="flex w-full mx-auto justify-center">
                <nv-search-box
                  :label="$t('find_help')"
                  debounce="1500"
                  @nvChange="handleSearch"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Topics -->
      <SupportProductTopics :product="product!"/>
  
      <!-- Topics -->
      <SupportProductRecentActivity :product="product!"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Packages

// Types
import type { InputChangeEventDetail } from '@nuiverse/core/dist/types/interface';
import { useProductStore } from '~/store/product';

definePageMeta({
  layout: 'support',
  middleware: 'check-product-slug'
});

// ---------------------------------------
// Hooks
// ---------------------------------------
const router = useRouter();
const { t } = useI18n();
const localePath = useLocalePath();

// --------------------------------------
// Store
// --------------------------------------

const productStore = useProductStore(); 
const { product } = storeToRefs(productStore);

function handleSearch({ detail: { value = '' } }: CustomEvent<InputChangeEventDetail>) {
  if (value && value.length >= 3) {
    router.push({
      path: localePath('/support/search'),
      query: {
        query: encodeURI(value),
      },
    });
  }
}

useHead({
  title: t('product_help', { name: product.value?.name })
})

</script>

<style lang="scss" scoped>
/*
* Mixes
*/
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/mixins/_breakpoints';

.topics-list,
.articles-list {
  color: inherit;
  list-style: none;

  a {
    color: inherit;
  }
}

.topics-list {
  column-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  row-gap: 24px;

  li {
    background: var(--nv-theme);
    border-radius: 8px;
    padding: 16px;

    &:hover {
      box-shadow: 0 0 4px 4px rgba(0, 99, 180, 0.12);
      cursor: pointer;
    }

    img {
      height: 40px;
      margin-right: 8px;
      width: 40px;
    }
  }
}

.articles-list {
  column-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(248px, 1fr));
  row-gap: 24px;

  li {
    background: var(--nv-theme);
    border-radius: 8px;
    color: initial;
    height: 100%;
    padding: 24px;

    span {
      -webkit-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }

    &:hover {
      box-shadow: 0 0 4px 4px rgba(0, 99, 180, 0.12);
      cursor: pointer;
    }

    img {
      height: 24px;
      margin-right: 8px;
      width: 24px;
    }
  }
}

.welcome-section {
  align-items: center;
  border-radius: 8px;
  display: flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 550px;
  overflow: hidden;
  position: relative;

  nv-search-box {
    max-width: 800px;
    width: 100%;
  }

  h2 {
    color: #fff;
    text-align: center;
    text-shadow: 2px 2px 4px #1f506e;
  }

  img {
    height: 104px;
    width: 104px;
  }

  .bg {
    background-image: url('https://assets.nuinalp.com/illustrations/account/sign-wallpaper-optimized.svg');
    background-position-y: 20%;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;

    &::before {
      background-color: rgba(31, 80, 110, 0.35);
      content: '';
      height: 100%;
      left: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}

</style>
